import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import liff from "@line/liff";
import Header from "../components/common/Header";
import WordCard from "../components/home/WordCard";
import BottomNav from "../components/common/BottomNav";
import AddWordModal from "../components/home/AddWordModal";
import { ensureLiffInit } from "../liffClient";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import { colors, fontFamily } from "../theme/palette";

function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);
  const [checking, setChecking] = useState(true);
  const [loginFailed, setLoginFailed] = useState(false);

  useEffect(() => {
    const load = async () => {
      const ready = await ensureLiffInit();
      setLoggedIn(ready && liff.isLoggedIn());
      setChecking(false);
    };

    load();
  }, []);

  useEffect(() => {
    if (loggedIn && searchParams.get("add") === "1") {
      setAddModalOpen(true);
      setSearchParams({}, { replace: true });
    }
  }, [loggedIn, searchParams, setSearchParams]);

  const handleLogin = async () => {
    const ok = await ensureLiffInit();
    if (!ok) {
      setLoginFailed(true);
      return;
    }
    liff.login();
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: colors.bg, display: "flex", flexDirection: "column" }}>
      <Box sx={{ width: "100%", position: "sticky", top: "0", zIndex: 100 }}>
        <Header />
      </Box>

      <Box sx={{ maxWidth: 720, mx: "auto", px: 2, pt: 4, pb: 2, flex: 1, width: "100%" }}>
        {/* Page heading */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 4 }}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "13px",
              background: colors.accent,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MenuBookRoundedIcon sx={{ color: "#fff", fontSize: 22 }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.4rem",
                color: colors.textPrimary,
                lineHeight: 1.2,
                fontFamily,
              }}
            >
              My Words
            </Typography>
            <Typography sx={{ fontSize: "0.8rem", color: colors.textMuted, fontFamily }}>
              学習中の単語リスト
            </Typography>
          </Box>
        </Box>

        {!checking && !loggedIn && (
          <Box
            sx={{
              backgroundColor: colors.card,
              borderRadius: "18px",
              p: 3,
              textAlign: "center",
              boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
              border: `1px solid ${colors.border}`,
            }}
          >
            <Typography sx={{ color: colors.textSecondary, fontSize: "0.9rem", mb: 2, fontFamily }}>
              ログインすると単語帳を利用できます
            </Typography>
            <Button
              onClick={handleLogin}
              variant="contained"
              sx={{
                background: colors.accent,
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontFamily,
                px: 3,
                "&:hover": { background: colors.accentDark },
              }}
            >
              LINEでログイン
            </Button>
            {loginFailed && (
              <Typography sx={{ color: colors.danger, fontSize: "0.78rem", mt: 1.5, fontFamily }}>
                ログインに接続できませんでした。時間をおいて再度お試しください。
              </Typography>
            )}
          </Box>
        )}

        {loggedIn && <WordCard refreshKey={refreshKey} />}
      </Box>

      {loggedIn && (
        <AddWordModal
          open={addModalOpen}
          onClose={() => setAddModalOpen(false)}
          onAdded={() => setRefreshKey((k) => k + 1)}
        />
      )}

      <BottomNav />
    </Box>
  );
}

export default App;
